import React from 'react';
interface PaxStatementFooterProps {
  company: {
    name: string;
    address: string;
    phone: string;
    email: string;
  };
}
export function PaxStatementFooter({
  company
}: PaxStatementFooterProps) {
  return <div className="pt-6 border-t border-neutral-200 text-center" data-id="element-726">
      <p className="text-xs text-neutral-500" data-id="element-727">
        {company.name} • {company.address} • {company.phone} • {company.email}
      </p>
    </div>;
}